<template>
  <div v-loading="loading" class="" style="padding: 20px;">
    <h2 style="text-align: center;margin-block-start: 0;margin-block-end: 0;">
      {{ title }} 附件列表
      <span style="color: #8492a6; font-size: 12px">「{{ list.length }}个文件」</span>
    </h2>
    <el-table :data="list" :show-header="false" style="width: 100%">
      <el-table-column align="center">
        <template slot-scope="{row:{name,file_id,file_extension}}">
          <el-row>
            <el-col :span="12" style="text-align: right">
              <span style="margin-right: 12px;">{{ name }}</span>
            </el-col>
            <el-col :span="12" style="text-align: left;">
              <el-button v-if="extensions.indexOf(file_extension)!==-1"
                         type="text" size="mini" style="padding: 0;" @click="handelSee(file_id,name)">预览
              </el-button>
              <el-button v-else type="text" size="mini" style="padding: 0;" disabled>不可预览</el-button>

              <el-button type="text" size="mini" style="padding: 0;" @click="downLoadFile(file_id,name)">下载
              </el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <template>
      <vue-office-docx v-if="docx" :src="docx" style="height: 100vh;"/>
      <vue-office-pdf v-if="pdf" :src="pdf" style="height: 100vh;"/>
      <img v-if="img" :src="img" style="max-width:80%;display: block;margin: 20px auto;" alt=""/>
    </template>
  </div>
</template>

<script>
import {getContractAnnexList} from "@/api/adOrder";
import {orderCovenantFileList} from "@/api/orderCovenant";
import {downloadByFileId} from "@/api/download_file";
import VueOfficePdf from '@vue-office/pdf'
import VueOfficeDocx from '@vue-office/docx'
import '@vue-office/docx/lib/index.css'

const extensions = ['pdf', 'docx', 'png', 'jpg', 'gif', 'jpeg'];
export default {
  name: "files",
  components: {VueOfficeDocx, VueOfficePdf},
  data() {
    return {
      loading: false,
      extensions,
      title: '',
      docx: '',
      pdf: '',
      img: '',
      list: []
    }
  },
  watch: {
    "$route.query.covenant_id"() {
      this.init();
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.setTitle();
      this.getData();
    },
    async setTitle() {
      this.title = this.$route.query.covenant_title || this.$route.query.title
    },
    getFileExtension(fileName) {
      if (!fileName)
        return null
      return fileName.substring(fileName.lastIndexOf('.') + 1);
    },
    async handelSee(id, fileName) {
      const fileExtension = this.getFileExtension(fileName)
      this.loading = true
      const response = await downloadByFileId({id})
      this.loading = false
      switch (fileExtension) {
        case 'pdf':
          this.docx = null
          this.img = null
          this.pdf = response.data
          break;
        case 'docx':
          this.pdf = null
          this.img = null
          this.docx = response.data
          break;
        case 'png':
        case 'jpg':
        case 'gif':
        case 'jpeg':
          this.pdf = null
          this.docx = null
          this.img = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          break;
      }
    },
    async getData() {
      let list
      if (this.$route.query.type === 'contract') {
        const response = await getContractAnnexList({contract_id: this.$route.query.id})
        list = response.data.list || []
      } else {
        const response = await orderCovenantFileList({covenant_id: this.$route.query.covenant_id})
        list = response.model || []
      }

      if (Array.isArray(list) && list.length) {
        await this.handelSee(list[0].file_id, list[0].name)

        list.map(_ => {
          _.file_extension = this.getFileExtension(_.name)
        })
      }
      this.list = list
    },
    async downLoadFile(id, name) {
      try {
        let isFileSaverSupported = !!new Blob()
        if (isFileSaverSupported) {
          const response = await downloadByFileId({id})
          const data = response.data
          const contentType = response.headers['content-type']
          const blob = new Blob([data], {type: contentType})
          this.FileSaver.saveAs(blob, decodeURI(name), {autoBom: true})
        } else {
          this.$message.warning('浏览器不支持导出文件')
        }
      } catch (e) {
        this.$message.warning(e.message)
      }
    },
  }
}
</script>

<style scoped>

</style>
